import React from 'react'
import "./index.css"
import { EMPTY_CART_LIST_API } from '../../../../APIs'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { CHECKOUTPAGE, PRE_CHECKOUTPAGE } from '../../../../constants/RoutingPath'

const CartButton = ({ fetchCartList, setCartData, setReserVationData, closeFuncState , timeRemaining }) => {

    const navigate = useNavigate()

    const hanldeClearCart = async () => {
        try {
            const response = await EMPTY_CART_LIST_API()
            if (response && response?.status) {
                fetchCartList()
                setCartData([])
                setReserVationData([])
                toast.success(response?.message)
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.log(error, "clear_cart_list")
        }
    }

    const handleRedirectToCheckout = () => {
        navigate(PRE_CHECKOUTPAGE)
        closeFuncState(false)
        document.body.style.overflow = "auto";
    }

    return (
        <div className="cart-buttons">
            <button className="btn empty-cart"  onClick={hanldeClearCart} >Empty Cart</button>
            <button className="btn checkout" disabled={timeRemaining === "Time expired"} onClick={handleRedirectToCheckout} >Continue to Pre-Checkout</button>
        </div>
    )
}

export default CartButton;